import { createSlice } from "@reduxjs/toolkit";

interface NetworkState {
    isOnline: boolean;
}

const initialState: NetworkState = {
    isOnline: true
}

const networkSlice = createSlice({
    name: "network",
    initialState,
    reducers: {
        setIsOnline: (state, action) => {
            state.isOnline = action.payload
        }
    }
})

export const { setIsOnline } = networkSlice.actions;
export default networkSlice.reducer